/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GameSessionStatisticsDto model module.
 * @module model/GameSessionStatisticsDto
 * @version v0
 */
class GameSessionStatisticsDto {
    /**
     * Constructs a new <code>GameSessionStatisticsDto</code>.
     * @alias module:model/GameSessionStatisticsDto
     */
    constructor() { 
        
        GameSessionStatisticsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GameSessionStatisticsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GameSessionStatisticsDto} obj Optional instance to populate.
     * @return {module:model/GameSessionStatisticsDto} The populated <code>GameSessionStatisticsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GameSessionStatisticsDto();

            if (data.hasOwnProperty('sessionId')) {
                obj['sessionId'] = ApiClient.convertToType(data['sessionId'], 'Number');
            }
            if (data.hasOwnProperty('sessionType')) {
                obj['sessionType'] = ApiClient.convertToType(data['sessionType'], 'String');
            }
            if (data.hasOwnProperty('totalPagesVisited')) {
                obj['totalPagesVisited'] = ApiClient.convertToType(data['totalPagesVisited'], 'Number');
            }
            if (data.hasOwnProperty('totalTimeMinutes')) {
                obj['totalTimeMinutes'] = ApiClient.convertToType(data['totalTimeMinutes'], 'Number');
            }
            if (data.hasOwnProperty('completionRate')) {
                obj['completionRate'] = ApiClient.convertToType(data['completionRate'], 'Number');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('lastActivityAt')) {
                obj['lastActivityAt'] = ApiClient.convertToType(data['lastActivityAt'], 'Date');
            }
            if (data.hasOwnProperty('totalQuestionsAnswered')) {
                obj['totalQuestionsAnswered'] = ApiClient.convertToType(data['totalQuestionsAnswered'], 'Number');
            }
            if (data.hasOwnProperty('totalCorrectAnswers')) {
                obj['totalCorrectAnswers'] = ApiClient.convertToType(data['totalCorrectAnswers'], 'Number');
            }
            if (data.hasOwnProperty('accuracyRate')) {
                obj['accuracyRate'] = ApiClient.convertToType(data['accuracyRate'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GameSessionStatisticsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GameSessionStatisticsDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sessionType'] && !(typeof data['sessionType'] === 'string' || data['sessionType'] instanceof String)) {
            throw new Error("Expected the field `sessionType` to be a primitive type in the JSON string but got " + data['sessionType']);
        }

        return true;
    }


}



/**
 * @member {Number} sessionId
 */
GameSessionStatisticsDto.prototype['sessionId'] = undefined;

/**
 * @member {String} sessionType
 */
GameSessionStatisticsDto.prototype['sessionType'] = undefined;

/**
 * @member {Number} totalPagesVisited
 */
GameSessionStatisticsDto.prototype['totalPagesVisited'] = undefined;

/**
 * @member {Number} totalTimeMinutes
 */
GameSessionStatisticsDto.prototype['totalTimeMinutes'] = undefined;

/**
 * @member {Number} completionRate
 */
GameSessionStatisticsDto.prototype['completionRate'] = undefined;

/**
 * @member {Date} startedAt
 */
GameSessionStatisticsDto.prototype['startedAt'] = undefined;

/**
 * @member {Date} lastActivityAt
 */
GameSessionStatisticsDto.prototype['lastActivityAt'] = undefined;

/**
 * @member {Number} totalQuestionsAnswered
 */
GameSessionStatisticsDto.prototype['totalQuestionsAnswered'] = undefined;

/**
 * @member {Number} totalCorrectAnswers
 */
GameSessionStatisticsDto.prototype['totalCorrectAnswers'] = undefined;

/**
 * @member {Number} accuracyRate
 */
GameSessionStatisticsDto.prototype['accuracyRate'] = undefined;






export default GameSessionStatisticsDto;

